import { lazy } from 'react';

export const ReceiptsList = lazy(() => import('./pages/ReceiptsList'));
export const ReceiptNew = lazy(() => import('./pages/ReceiptNew'));
export const ReceiptsInbox = lazy(() => import('./pages/ReceiptsInbox'));
export const ReceiptDetail = lazy(() => import('./pages/ReceiptDetail'));

export { RECEIPT_ROUTES } from './paths';
